"use strict";
/**
* MCF-FIELD
*
* @since      1.0
* @package    Mindfolio
* @subpackage Mind Contact Form
* @author     Webmajstr <info@webmajstr.cz>
* @copyright  Copyright (c) 2021 Webmajstr
* @license    GPL2+
*/
exports.__esModule = true;
var MCF_Field = /** @class */ (function () {
    function MCF_Field(el_field, Val_regs) {
        this.Val_regs = Val_regs;
        this.el_field = el_field; // TODO check whether is a HTML element
        this.name = el_field.getAttribute('mcf-data');
        this.el_input = el_field.querySelector('.mcf-input');
        this.el_noval = el_field.querySelector('.mcf-noval');
        this.el_valid = el_field.querySelector('.mcf-validation-error') || null;
    }
    /**	RESET  - Resets the form before submit
     *	@since    1.0.0
     */
    MCF_Field.prototype.reset = function () {
        this.el_input.classList.remove('is-danger');
        this.el_noval.style.display = 'none';
        if (this.el_valid)
            this.el_valid.style.display = 'none';
    };
    MCF_Field.prototype.empty = function () {
        this.el_input.value = '';
    };
    /**	CHECK  - Checks the field for relevant data.
     *	@since    1.0.0
     */
    MCF_Field.prototype.check = function () {
        var val = this.el_input.value;
        var valid = this.el_field.getAttribute('validation');
        this.reset();
        if (!val && this.el_noval) { // if is empty
            console.log('field ' + this.name + 'is empty');
            this.el_noval.style.display = 'block';
            this.el_input.classList.add('is-danger');
            return false;
        }
        else if (this.el_valid && valid) { // if has validation condition
            if (!this.Val_regs[valid].test(val)) {
                this.el_valid.style.display = 'block';
                return false;
            }
        }
        return true;
    };
    return MCF_Field;
}());
exports["default"] = MCF_Field;
